import React from "react"
import PropTypes from "prop-types"
import { Card, Typography, Avatar, Box, Tooltip } from "@mui/material"
import { Link } from "react-router-dom"
import TemplateCardActions from "./TemplateCardActions"

const TemplateCard = ({ title, imageSrc, linkTo, actions }) => {
  return (
    <Card
      sx={{
        width: "100%",
        borderRadius: 2,
        position: "relative",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          transform: "scale(1.03)",
          boxShadow: 6,
        },
        padding: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          {...(linkTo && { component: Link, to: linkTo })}
          sx={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "inherit",
            "&:hover": {
              color: "inherit",
            },
            flexGrow: 1,
          }}
        >
          {imageSrc ? (
            <Box
              component="img"
              src={imageSrc}
              alt={title}
              sx={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                objectFit: "cover",
                marginRight: 2,
              }}
            />
          ) : (
            <Avatar
              sx={{
                width: 64,
                height: 64,
                bgcolor: "#FFEEAA",
                color: "#fff",
                fontSize: 32,
                marginRight: 2,
              }}
            >
              T
            </Avatar>
          )}

          <Tooltip title={title}>
            <Typography
              variant="body1"
              sx={{
                whiteSpace: "normal",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                flexGrow: 1,
              }}
            >
              {title}
            </Typography>
          </Tooltip>
        </Box>

        <TemplateCardActions actions={actions} />
      </Box>
    </Card>
  )
}

TemplateCard.propTypes = {
  title: PropTypes.string.isRequired,
  imageSrc: PropTypes.string,
  linkTo: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
    }),
  ),
}

export default TemplateCard
